"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountingSalaryConfigPropsWithWageType = exports.bonusAccountingSalaryConfigPropsWithWageType = exports.absenceAccountingSalaryConfigPropsWithWageType = void 0;
exports.updateAbsenceWageTypeNumber = updateAbsenceWageTypeNumber;
exports.removeAbsenceWageTypeNumber = removeAbsenceWageTypeNumber;
exports.updateBonusWageTypeNumber = updateBonusWageTypeNumber;
exports.removeBonusWageTypeNumber = removeBonusWageTypeNumber;
exports.updateAccountingSalaryConfigWageTypeNumber = updateAccountingSalaryConfigWageTypeNumber;
exports.removeAccountingSalaryConfigWageTypeNumber = removeAccountingSalaryConfigWageTypeNumber;
const model_1 = require("../model");
exports.absenceAccountingSalaryConfigPropsWithWageType = [
    "vacation",
    "compDay",
    "sick",
    "childSick",
    "sickInKUG",
];
exports.bonusAccountingSalaryConfigPropsWithWageType = [
    "night1",
    "night2",
    "sunday",
    "holiday",
    "special",
];
exports.accountingSalaryConfigPropsWithWageType = [
    "workHourly",
    "workMonthly",
    "workHourlyDays",
    "workMonthlyDays",
    "absenceHourly",
    "absenceHourlyDays",
    "absenceMonthly",
    "absenceMonthlyDays",
    "bonusTaxFree",
    "bonusTaxed",
    "mealsValue",
    "mealsBreakfast",
    "mealsLunch",
    "mealsDinner",
    "commission",
    "bonusAdvance",
    "payAdvance",
    "salary",
];
function updateAbsenceWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    exports.absenceAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}
function removeAbsenceWageTypeNumber(config, wageTypeNumber) {
    updateAbsenceWageTypeNumber(config, wageTypeNumber, "");
}
function updateBonusWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    exports.bonusAccountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
    });
    Object.assign(config, updated);
}
function removeBonusWageTypeNumber(config, wageTypeNumber) {
    updateBonusWageTypeNumber(config, wageTypeNumber, "");
}
function updateAccountingSalaryConfigWageTypeNumber(config, oldNumber, newNumber) {
    const updated = {};
    exports.accountingSalaryConfigPropsWithWageType.forEach((prop) => {
        if (config[prop] === oldNumber) {
            updated[prop] = newNumber;
        }
        // handle bonus and absence configs
        else if (config[prop] instanceof model_1.AbsenceAccountingSalaryConfig ||
            config[prop] instanceof model_1.BonusAccountingSalaryConfig) {
            if (config[prop] instanceof model_1.AbsenceAccountingSalaryConfig) {
                updateAbsenceWageTypeNumber(config[prop], oldNumber, newNumber);
            }
            else if (config[prop] instanceof model_1.BonusAccountingSalaryConfig) {
                updateBonusWageTypeNumber(config[prop], oldNumber, newNumber);
            }
        }
    });
    // handle benefits
    if (config.benefits) {
        config.benefits.forEach((benefit) => {
            if (benefit.wageTypeNumber === oldNumber) {
                benefit.wageTypeNumber = newNumber;
            }
        });
    }
    if (config.bonuses) {
        config.bonuses.forEach((bonus) => {
            if (bonus.taxed === oldNumber) {
                bonus.taxed = newNumber;
            }
            if (bonus.taxFree === oldNumber) {
                bonus.taxFree = newNumber;
            }
        });
    }
    Object.assign(config, updated);
}
function removeAccountingSalaryConfigWageTypeNumber(config, wageTypeNumber) {
    updateAccountingSalaryConfigWageTypeNumber(config, wageTypeNumber, "");
}
//# sourceMappingURL=wage-type.util.js.map